// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileOutlinedSvg from "@ant-design/icons-svg/es/asn/FileOutlined";
import AntdIcon from '../components/AntdIcon';

var FileOutlined = function FileOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileOutlinedSvg
  }));
};

FileOutlined.displayName = 'FileOutlined';
export default React.forwardRef(FileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileOutlined.js
// module id = 1123
// module chunks = 0